import script from "./Invoices.vue?vue&type=script&setup=true&lang=js"
export * from "./Invoices.vue?vue&type=script&setup=true&lang=js"

import "./Invoices.vue?vue&type=style&index=0&id=7de88862&lang=css"

const __exports__ = script;

export default __exports__